import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import styles from './index.css';


const Background = (props) => {
  const { videoNode } = props;

  const bgVideoRef = useRef();
  const [isPlaying, setIsPlaying] = useState(false);

  const onCopyAudioSettings = useCallback(() => {
    if (!videoNode?.mozCaptureStream || !bgVideoRef?.current) {
      return;
    }

    /**
     * FireFox destroys AudioSink of the original element
     * when using `mozCaptureStrean`.
     *
     * @link https://bugzilla.mozilla.org/show_bug.cgi?id=1178751
     */

    bgVideoRef.current.muted = videoNode.muted;
    bgVideoRef.current.volume = videoNode.volume;
  }, [videoNode, bgVideoRef]);

  const onDuplicateStream = useCallback(async() => {
    if (!videoNode) {
      return;
    }

    let stream = videoNode.captureStream?.();
    if (!stream) {
      stream = videoNode.mozCaptureStream?.();
    }

    if (!bgVideoRef?.current || !stream) {
      return;
    }

    bgVideoRef.current.srcObject = stream;

    try {
      await bgVideoRef.current.play();
    } catch (err) {
      // Nothing to do here
    }

    if (!bgVideoRef.current?.playing) {
      return;
    }

    onCopyAudioSettings();
    setIsPlaying(true);
  }, [videoNode, bgVideoRef, onCopyAudioSettings]);

  useEffect(() => {
    if (videoNode?.playing) {
      onDuplicateStream();
    } else {
      videoNode?.addEventListener('play', onDuplicateStream);
    }

    videoNode?.addEventListener('volumechange', onCopyAudioSettings);

    return () => {
      videoNode?.removeEventListener('play', onDuplicateStream);
      videoNode?.removeEventListener('volumechange', onCopyAudioSettings);
    };
  }, [videoNode, onDuplicateStream, onCopyAudioSettings]);

  return (
    <div
      className={styles.container}
      data-isplaying={isPlaying}
      data-name="Background"
    >
      <video
        ref={bgVideoRef}
        className={styles.background}
        controls={false}
        controlsList="nodownload"
        data-id="blurredBackground"
        disablePictureInPicture={true}
        muted={true}
      />
    </div>
  );
};

Background.propTypes = { videoNode: PropTypes.any };

Background.defaultProps = { videoNode: undefined };

export default Background;
